import { useState } from 'react';
import { DropResult } from 'react-beautiful-dnd';
import { deepCopy } from 'utils/deepCopy';

export const useStrengthPackSIzeNdcManagementModal = (
  initialData: {
    strength: string;
    packsize: number;
    ndc: string | null;
  }[],
  handleSaveData: (
    data: {
      strength: string;
      packsize: number;
      ndc: string | null;
    }[],
    rowIndex: number
  ) => void,
  rowIndex: number
) => {
  const [data, setData] = useState(initialData);

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) {
      return;
    }

    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;

    if (sourceIndex === destinationIndex) {
      return;
    }

    const reorderedData = deepCopy(data);
    const [removed] = reorderedData.splice(sourceIndex, 1);
    reorderedData.splice(destinationIndex, 0, removed);

    setData(reorderedData);
    handleSaveData(reorderedData, rowIndex);
  };

  const inputOperations = {
    ndc: {
      value: (rowIndex: number) => {
        return data[rowIndex].ndc;
      },
      onChange: (rowIndex: number, value: string) => {
        const copyEntryData = deepCopy(data);
        copyEntryData[rowIndex].ndc = value as unknown as string;
        handleSaveData(copyEntryData, rowIndex);
        setData(copyEntryData);
      },
    },
    packSize: {
      value: (rowIndex: number) => {
        return data[rowIndex].packsize;
      },
      onChange: (rowIndex: number, value: string) => {
        const copyEntryData = deepCopy(data);
        copyEntryData[rowIndex].packsize = value as unknown as number;
        handleSaveData(copyEntryData, rowIndex);
        setData(copyEntryData);
      },
    },
    strength: {
      value: (rowIndex: number) => {
        return {
          code: data[rowIndex].strength.toLowerCase(),
          name: data[rowIndex].strength.toLowerCase(),
        };
      },
      onChange: (rowIndex: number, value: string) => {
        const copyEntryData = deepCopy(data);
        copyEntryData[rowIndex].strength = value;
        setData(copyEntryData);
        handleSaveData(copyEntryData, rowIndex);
      },
    },
  };

  return {
    inputOperations,
    handleDragEnd,
  };
};
